import { Directive, ElementRef, TemplateRef } from '@angular/core';

@Directive({
    selector: '[appTabContent]',
    standalone: false
})
export class TabContentDirective {
  constructor(readonly templateRef: TemplateRef<ElementRef<HTMLElement>>) {}
}
